import { getDNAEvents } from '../../libraries/api/domains'
import { getEventsForCameraUUID, parseEventPoints } from '../../libraries/api/events'
import { getRangeForWindow } from '../../libraries/util/timeline'

export const DnaModule = {
  namespaced: true,
  state: {
    cameraDetections: undefined,
    cameraAlerts: undefined,
    showDetections: true,
    window: {},
    filterDetectable: undefined,
    filteredCameraDetections: undefined,
  },
  mutations: {
    addCameraAlerts (state, alerts) {
      state.cameraAlerts = alerts
    },
    addCameraDetections (state, detections) {
      if (state.cameraDetections) {
        const incoming = Object.assign({}, state.cameraDetections, detections)
        state.cameraDetections = incoming
      } else state.cameraDetections = detections
    },
    shouldShowDetections (state) {
      state.showDetections = true
    },
    setWindow (state, window) {
      state.window = window
    },
    clearDetections (state) {
      state.cameraDetections = undefined
    },
    setFilterDetectable (state, detectable) {
      state.filterDetectable = detectable
    },
    filterDetectionsByDetectable (state, detectable) {
      if (detectable !== undefined && detectable !== 'all') {
        let filteredDetections = {}
        for (var detection in state.cameraDetections) {
          var filtered = state.cameraDetections[detection].filter(x => {
            return x.className === detectable
          })
          filteredDetections[detection] = filtered
        }
        state.filteredCameraDetections = filteredDetections
      } else {
        state.filteredCameraDetections = state.cameraDetections
      }
    },
  },
  getters: {
    showDetections (state) {
      return state.showDetections
    },
    cameraEvents (state) {
      let events = state.cameraAlerts
      // console.log('RETURNING EVENTS GETTER')
      return events
    },
    cameraAlerts (state) {
      return state.cameraAlerts
    },
    cameraDetections (state, getters) {
      let detections = state.cameraDetections
      return detections
    },
    sortedDetectionBlocks (state) {
      if (state.cameraDetections) {
        const sorted = Object.keys(state.cameraDetections).sort((blockA, blockB) => {
          return blockA > blockB ? 1 : blockA < blockB ? -1 : 0
        })
        return sorted
      }
    },
    window (state) {
      return state.window
    },
    range (state) {
      if (state.window !== {}) {
        return getRangeForWindow(state.window.start, state.window.end)
      }
    },
    detectableFilter (state) {
      return state.filterDetectable
    },
    filteredCameraDetections (state) {
      return state.filteredCameraDetections
    },
  },
  actions: {
    getCameraAlerts ({ state, commit, rootState }, params) {
      const { domainUUID, cameraUUID, options } = params
      // options.limit = options.limit || 1500
      return getEventsForCameraUUID(domainUUID, cameraUUID, options)
        .then(res => res.data)
        .then(res => {
          const incoming = parseEventPoints(res.data)
          commit('addCameraAlerts', incoming)
        })
        .catch(error => console.error(`Failed to load timeline: `, error))
    },
    getCameraDetections ({ state, commit, rootState }, params) {
      const {
        dnaId,
        start,
        end,
      } = params
      const queryParams = `?start=${start}&end=${end}`
      return getDNAEvents(dnaId, queryParams).then(res => {
        commit('addCameraDetections', res.data.detections)
      })
    },
  },
}
